<div class="layout-wrapper" [ngClass]="{'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple,
      'layout-menu-static': isStatic(),
      'layout-menu-overlay': isOverlay(),
      'layout-menu-horizontal': isHorizontal(),
      'layout-menu-slim': isSlim(),
      'layout-menu-active': menuActive,
      'layout-menu-mobile-active': mobileMenuActive,
      'layout-locked': locked,
      'layout-rightmenu-active': rightMenuActive,
      'layout-mobile-top-navigation': mobileTopNavigationActive,
      'layout-mobile-top-navigation--collapsed': mobileTopNavigationActive && mobileTopNavigationCollapsed,
      'layout-chat-fullscreen': chatFullscreenMobile,
      'layout-rtl': app.isRTL}" [class]="'layout-menu-' + app.menuTheme + ' layout-topbar-' + app.topbarTheme">

  <div class="safe-area">
  </div>
  <app-topbar *ngIf="topbarVisible && !mobileTopNavigationActive" [user]="user"></app-topbar>
  <app-mobile-top-navigation
    *ngIf="mobileTopNavigationActive"
    [user]="user"
    (drawerRequested)="openMobileDrawer()"
    (collapsedChange)="onMobileTopNavigationCollapsedChange($event)"
  ></app-mobile-top-navigation>

  <app-rightmenu *ngIf="isLoggedIn && !mobileTopNavigationActive"></app-rightmenu>

  <div class="menu-wrapper" *ngIf="isLoggedIn" (click)="onMenuClick($event)">
    <div class="layout-menu-container" #mobileMenuDrawer>
      <app-inline-menu *ngIf="app.inlineMenuPosition=='top' || app.inlineMenuPosition=='both'" key="top" [user]="user"></app-inline-menu>
      <app-menu></app-menu>
      <app-inline-menu *ngIf="app.inlineMenuPosition=='bottom' || app.inlineMenuPosition=='both'" key="bottom" [user]="user"></app-inline-menu>
    </div>
  </div>

  <div class="layout-main" (click)="onMainLayoutClick()">
    <app-breadcrumb [class.mobile-top-navigation__legacy-breadcrumb]="mobileTopNavigationActive"></app-breadcrumb>
    <div class="layout-content mobile-stack-transition-surface" appMobileStackTransition>
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer *ngIf="isLoggedIn && footerVisible" [user]="user"></app-footer>
  <app-config *ngIf="isLoggedIn"></app-config>

  <div *ngIf="mobileMenuActive" class="layout-mask modal-in"></div>
</div>
